const LATITUDE = 39.900884;
const LONGITUDE = -105.0860904;

export async function getWeatherWarningsByLatLon() {
  const pointUrl = `https://api.weather.gov/points/${LATITUDE},${LONGITUDE}`;

  try {
    // Step 1: Get forecast zone info
    const pointRes = await fetch(pointUrl);

    if (!pointRes.ok) {
      console.log(`Point lookup failed: ${pointRes.status}`);
      return null;
    }

    const pointData = await pointRes.json();
    const zone = pointData.properties.forecastZone.split("/").pop();

    // Step 2: Query alerts for that zone
    const alertsUrl = `https://api.weather.gov/alerts/active/zone/${zone}`;
    const alertsRes = await fetch(alertsUrl);

    if (!alertsRes.ok) {
      console.log(`Alert lookup failed: ${alertsRes.status}`);
      return null;
    }

    const alertsData = await alertsRes.json();
    return alertsData.features.map((feature) => {
      return {
        description: feature.properties.event,
        severity: feature.properties.severity, // Extreme, Severe, Moderate, Minor, Unknown
      };
    }); // Array of alerts
  } catch (error) {
    console.error("Error fetching weather warnings:", error);
    return null;
  }
}
